import { BlobUploadResponse } from "./blob-upload";

export interface KnowledgeBaseCreatePayload {
  knowledgeBaseDetails : KnowledgeBaseContent;
}

export interface KnowledgeBaseContent {
  _id: string;
  siteId: string;
  kbId: null,
  title: string;
  description: string;
  area: string;
  category: string;
  fileDetails: {
    file: {
      url: string;
      type: string;
      size: number;
      name: string;
    },
    thumbnail: {
      url: string;
      type: string;
      size: number;
      name: string;
    }    
  },
  details: {
    comments: string[];
    hashtag: string[];
    totalViews: number;
    totalLikes: number;
    starRating: {
      rating: number;
      headCount: number;
    }
  },
  metadata: {
    createdBy: string;
    createdDate: Date;
    modifiedBy: string;
    modifiedDate: Date;
  }
  author: string;
  estimatedTime: string;
}

export interface KnowledgeBaseContentFiles {
  file: string;
  thumbnail: string;
}

export interface KnowledgeBaseCreateContent {
  siteId: string;
  title: string;
  description: string;
  area: string;
  category: string;
  fileDetails: {
    file: {
      url: string;
      type: string;
      size: number;
      name: string;
    },
    thumbnail: {
      url: string;
      type: string;
      size: number;
      name: string;
    }    
  },
  details: {
    comments: string[];
    hashtag: string[];
    totalViews: number;
    totalLikes: number;
    starRating: {
      rating: number;
      headCount: number;
    }
  },
  author: string;
  estimatedTime: string;
}

export interface KnowledgeBasePayloadResponse {
  status: boolean;
  response: {
    message: string;
  }
}

export interface KnowledgeBaseGetListPayloadResponse {
  status: boolean;
  response: {
    data: KnowledgeBaseListContent[];
    pageInfo: {
      currentPage: number;
      endIndex: number;
      endPage: boolean;
      pageCount: number;
      pages: number[];
      startIndex: number;
      totalItems: number;
    }
  }
}

export interface KnowledgeBaseListViewRefresh {
  status: boolean;
  time: Date;
}

export interface KnowledgeBaseListContent {
  _id: string;
  kbId: string;
  title: string;
  description: string;
  area: string;
  category: string;
  fileDetails: {
    file: {
      url: string;
      type: string;
      size: number;
      name: string;
    },
    thumbnail: {
      url: string;
      type: string;
      size: number;
      name: string;
    }    
  }
  author: string;
  estimatedTime: string;
  metadata: {
    createdBy: string;
    createdDate: Date;
    modifiedBy: string;
    modifiedDate: Date;
  },
  userName: string;
}

export type KnowledgeBaseModalActionType = 'add' | 'view' | 'edit' | 'delete' | 'download';

export interface KnowledgeBaseListAction {
  type: KnowledgeBaseModalActionType;
  item: KnowledgeBaseListContent;
}

export interface KnowledgeBaseDetailsPayloadResponse {
  status: boolean;
  response: {
    data: KnowledgeBaseContent[];
  }
}

export interface KnowledgeBaseConfigurationPayloadResponse {
  status: boolean;
  response: KnowledgeBaseConfigurationAttribute[];
}

export interface KnowledgeBaseConfigurationAttribute {
  attribute: string;
  group: string;
  siteId: string;
  tenantId: string;
  type: string;
  values: any;
}

export interface KnowledgeBaseConfigurationAttributeFileSizeFormat {
  fileSizeFormat: {
    file: number;
    thumbnail: number;
  }
}

export type KnowledgeBaseFilterType = 'area' | 'category' | 'keyword';

export interface KnowledgeBaseFilterList {
  type: KnowledgeBaseFilterType;
  value: string;
}

export interface KnowledgeBaseFilterOptions {
  area: string;
  category: string;
  keyword: string;
}

export interface KnowledgeBaseBlobResponse {
  file: Partial<BlobUploadResponse>,
  thumbnail: Partial<BlobUploadResponse>
}

export interface KnowledgeBaseStatisticsContent {
  count: string;
  _id: string;
}

export interface KnowledgeBaseStatisticsList {
  categoryRepresentation: KnowledgeBaseStatisticsContent[],
  areaPathRepresentation: KnowledgeBaseStatisticsContent[]
}

export interface KnowledgeBaseStatisticsPayloadResponse {
  status: boolean;
  response: {
    data: KnowledgeBaseStatisticsList[];
  }
}
